import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import Pos from '../ui/pages/pos/view';
import ProfilePage from '../ui/pages/profile/view';
import GeneralLayout from '../ui/templates/view';

export class Cashier {
    getRoutes() {
        return (
            <Router>
                <Routes>
                    <Route path="/pos" element={<GeneralLayout child={<Pos />} />} />
                    <Route path="/profile" element={<GeneralLayout child={<ProfilePage />} />} />
                    <Route path="/" element={<Navigate to="/pos" replace />} />
                    <Route path="*" element={<Navigate to="/pos" replace />} />
                </Routes>
            </Router>
        );
    }
}
